import * as React from 'react';
import { useState } from 'react';
import './dropdownWithInput.scss';
import { Placeholder } from 'semantic-ui-react';

type DropDownProps = {
    label?: string;
    options: string[];
    placeHolder?: string;
};

const DropDown = ({ label, options, placeHolder }: DropDownProps) => {
    const [value, setValue] = useState<string>(placeHolder ? placeHolder : '');
    return (
        <>
            <div className="dropdownWithInput">
                <div className="InputLabel"> {label}</div>
                <div className="inputWrapper">
                    <div className="selectWrapper">
                        <select className="selectField">
                            {options.map((option: string) => {
                                return <option value={option}>{option}</option>;
                            })}
                        </select>
                    </div>
                    <div className="textInputWrapper">
                        <input
                            value={value}
                            className="textInput"
                            onChange={(e) => {
                                setValue(e.target.value);
                            }}
                            onClick={() => {
                                setValue('');
                            }}
                            style={{
                                color: value !== placeHolder ? 'black' : '',
                            }}
                        />

                        <div className="textLabel">원</div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default DropDown;
